export default __webpack_public_path__ + "static/media/rmdlogo.42c7194a.png";